export default {
  passwordRequirement: 'dt.components.shared.auth.passwordRequirement',
  passwordRequirementCheckIcon: 'dt.components.shared.auth.passwordRequirementCheckIcon',
  passwordRequirementXIcon: 'dt.components.shared.auth.passwordRequirementXIcon',
  passwordError: 'dt.components.shared.auth.passwordError',
  passwordInput: 'dt.components.shared.auth.passwordInput',
  confirmPasswordInput: 'dt.components.shared.auth.confirmPasswordInput',
  signIn: {
    emailInput: 'dt.components.shared.auth.signIn.emailInput',
    emailInputError: 'dt.components.shared.auth.signIn.emailInputError',
    forgotPasswordLink: 'dt.components.shared.auth.signIn.forgotPasswordLink',
    form: 'dt.components.shared.auth.signIn.form',
    passwordInput: 'dt.components.shared.auth.signIn.passwordInput',
    passwordInputError: 'dt.components.shared.auth.signIn.passwordInputError',
    signUpLink: 'dt.components.shared.auth.signIn.signUpLink',
    submitButton: 'dt.components.shared.auth.signIn.submitButton',
    signInViaRypButton: 'dt.components.shared.auth.signIn.signInViaRypButton',
  },
  signUp: {
    accordionTrigger: 'dt.components.shared.auth.signUp.accordionTrigger',
    emailError: 'dt.components.shared.auth.signUp.emailError',
    emailInput: 'dt.components.shared.auth.signUp.emailInput',
    confirmEmailError: 'dt.components.shared.auth.signUp.confirmEmailError',
    confirmEmailInput: 'dt.components.shared.auth.signUp.confirmEmailInput',
    form: 'dt.components.shared.auth.signUp.form',
    passwordError: 'dt.components.shared.auth.signUp.passwordError',
    passwordInput: 'dt.components.shared.auth.signUp.passwordInput',
    signInLink: 'dt.components.shared.auth.signUp.signInLink',
    submitButton: 'dt.components.shared.auth.signUp.submitButton',
    handleError: 'dt.components.shared.auth.signUp.handleError',
    handleInput: 'dt.components.shared.auth.signUp.handleInput',
    nameError: 'dt.components.shared.auth.signUp.nameError',
    nameInput: 'dt.components.shared.auth.signUp.nameInput',
    referralCodeError: 'dt.components.shared.auth.signUp.referralCodeError',
    referralCodeInput: 'dt.components.shared.auth.signUp.referralCodeInput',
    referralSuccessMessage: 'dt.components.shared.auth.signUp.referralSuccessMessage',
    promoCodeBanner: 'dt.components.shared.auth.signUp.promoCodeBanner',
  },
  signUpVersionTwo: {
    signUpIntro: {
      continueOnWebButton:
        'dt.components.shared.auth.signUpVersionTwo.signUpIntro.continueOnWebButton',
    },
    emailForm: {
      continueButton: 'dt.components.shared.auth.signUpVersionTwo.firstStep.continueButton',
    },
    passwordForm: {
      continueButton: 'dt.components.shared.auth.signUpVersionTwo.passwordForm.continueButton',
      progressBar: 'dt.components.shared.auth.signUpVersionTwo.passwordForm.progressBar',
    },
    handleForm: {
      errorMessage: 'dt.components.shared.auth.signUpVersionTwo.handleForm.errorMessage',
      inputField: 'dt.components.shared.auth.signUpVersionTwo.handleForm.inputField',
      continueButton: 'dt.components.shared.auth.signUpVersionTwo.handleForm.continueButton',
    },
    emailVerificationForm: {
      modal: 'dt.components.shared.auth.signUpVersionTwo.emailVerificationForm.modal',
      pinInput: 'dt.components.shared.auth.signUpVersionTwo.emailVerificationForm.pinInput',
      resendButton: 'dt.components.shared.auth.signUpVersionTwo.emailVerificationForm.resendButton',
      incorrectEmailButton:
        'dt.components.shared.auth.signUpVersionTwo.emailVerificationForm.incorrectEmailButton',
      errorMessage: 'dt.components.shared.auth.signUpVersionTwo.emailVerificationForm.errorMessage',
      successIcon: 'dt.components.shared.auth.signUpVersionTwo.emailVerificationForm.successIcon',
      startOverButton:
        'dt.components.shared.auth.signUpVersionTwo.emailVerificationForm.startOverButton',
    },
    verificationTypeForm: {
      manualOption: 'dt.components.shared.auth.signUpVersionTwo.verificationTypeForm.manualOption',
      proveOption: 'dt.components.shared.auth.signUpVersionTwo.verificationTypeForm.proveOption',
      continueButton: 'dt.components.shared.auth.signUpVersionTwo.handleForm.continueButton',
    },
    nameForm: {
      firstName: 'dt.components.shared.auth.signUpVersionTwo.nameForm.firstName',
      lastName: 'dt.components.shared.auth.signUpVersionTwo.nameForm.lastName',
      monthField: 'dt.components.shared.auth.signUpVersionTwo.nameForm.monthField',
      dateField: 'dt.components.shared.auth.signUpVersionTwo.nameForm.dateField',
      yearField: 'dt.components.shared.auth.signUpVersionTwo.nameForm.yearField',
      continueButton: 'dt.components.shared.auth.signUpVersionTwo.nameForm.continueButton',
    },
    addressForm: {
      countryInputField: 'dt.components.shared.auth.signUpVersionTwo.addressForm.countryInputField',
      addressInputField: 'dt.components.shared.auth.signUpVersionTwo.addressForm.addressInputField',
      cityInputField: 'dt.components.shared.auth.signUpVersionTwo.addressForm.cityInputField',
      stateInputField: 'dt.components.shared.auth.signUpVersionTwo.addressForm.stateInputField',
      zipCodeInputField: 'dt.components.shared.auth.signUpVersionTwo.addressForm.zipCodeInputField',
      phoneNumberInputField:
        'dt.components.shared.auth.signUpVersionTwo.addressForm.phoneNumberInputField',
      continueButton: 'dt.components.shared.auth.signUpVersionTwo.addressForm.continueButton',
    },
    confirmationModal: {
      confirmationModal:
        'dt.components.shared.auth.signUpVersionTwo.confirmationModal.confirmationModal',
      title: 'dt.components.shared.auth.signUpVersionTwo.confirmationModal.title',
      description: 'dt.components.shared.auth.signUpVersionTwo.confirmationModal.description',
      confirmButton: 'dt.components.shared.auth.signUpVersionTwo.confirmationModal.confirmButton',
      goBackButton: 'dt.components.shared.auth.signUpVersionTwo.confirmationModal.goBackButton',
    },
    existingAccountModal: {
      modal: 'dt.components.shared.auth.signUpVersionTwo.existingAccountModal.modal',
      title: 'dt.components.shared.auth.signUpVersionTwo.existingAccountModal.title',
      description: 'dt.components.shared.auth.signUpVersionTwo.existingAccountModal.description',
      logInButton: 'dt.components.shared.auth.signUpVersionTwo.existingAccountModal.logInButton',
      useDifferentEmailButton:
        'dt.components.shared.auth.signUpVersionTwo.existingAccountModal.useDifferentEmailButton',
    },
    tooManyAttemptsModal: {
      modal: 'dt.components.shared.auth.signUpVersionTwo.tooManyAttemptsModal.modal',
      title: 'dt.components.shared.auth.signUpVersionTwo.tooManyAttemptsModal.title',
      description: 'dt.components.shared.auth.signUpVersionTwo.tooManyAttemptsModal.description',
      contactSupportButton:
        'dt.components.shared.auth.signUpVersionTwo.tooManyAttemptsModal.contactSupportButton',
      cancelButton: 'dt.components.shared.auth.signUpVersionTwo.tooManyAttemptsModal.cancelButton',
    },
    proveVerificationModal: {
      modal: 'dt.components.shared.auth.signUpVersionTwo.proveVerificationModal.modal',
      codeInput: 'dt.components.shared.auth.signUpVersionTwo.proveVerificationModal.codeInput',
      verifyButton:
        'dt.components.shared.auth.signUpVersionTwo.proveVerificationModal.verifyButton',
      tryAgainLink:
        'dt.components.shared.auth.signUpVersionTwo.proveVerificationModal.tryAgainLink',
    },
    confirmInfoCard: {
      editButton: 'dt.components.shared.auth.signUpVersionTwo.confirmInfoCard.editButton',
      confirmCheckbox: 'dt.components.shared.auth.signUpVersionTwo.confirmInfoCard.confirmCheckbox',
      continueButton: 'dt.components.shared.auth.signUpVersionTwo.confirmInfoCard.continueButton',
    },
    kycDetailsForm: {
      firstNameInput: 'dt.components.shared.auth.signUpVersionTwo.kycDetailsForm.firstNameInput',
      lastNameInput: 'dt.components.shared.auth.signUpVersionTwo.kycDetailsForm.lastNameInput',
      monthField: 'dt.components.shared.auth.signUpVersionTwo.kycDetailsForm.monthField',
      dateField: 'dt.components.shared.auth.signUpVersionTwo.kycDetailsForm.dateField',
      yearField: 'dt.components.shared.auth.signUpVersionTwo.kycDetailsForm.yearField',
      countryInput: 'dt.components.shared.auth.signUpVersionTwo.kycDetailsForm.countryInput',
      addressInput: 'dt.components.shared.auth.signUpVersionTwo.kycDetailsForm.addressInput',
      cityInput: 'dt.components.shared.auth.signUpVersionTwo.kycDetailsForm.cityInput',
      stateInput: 'dt.components.shared.auth.signUpVersionTwo.kycDetailsForm.stateInput',
      zipInput: 'dt.components.shared.auth.signUpVersionTwo.kycDetailsForm.zipInput',
      phoneInput: 'dt.components.shared.auth.signUpVersionTwo.kycDetailsForm.phoneInput',
      consentCheckbox: 'dt.components.shared.auth.signUpVersionTwo.kycDetailsForm.consentCheckbox',
      continueButton: 'dt.components.shared.auth.signUpVersionTwo.kycDetailsForm.continueButton',
    },
  },
};
